import Head from "next/head";
import MistakeTrainer from "./MistakeTrainer";
import useTranslation from "next-translate/useTranslation";

export default function MistakePracticePage() {
  const { t } = useTranslation("puzzles");
  return (
    <div className="mx-auto w-full px-3 py-4 md:px-6">
      <Head>
        <title>{t("mistakes.metaTitle")}</title>
      </Head>
      <MistakeTrainer />
    </div>
  );
}

export async function privatePracticeProps({ res }) {
  res.setHeader("Cache-Control", "private, no-store");
  res.setHeader("X-Robots-Tag", "noindex, nofollow");
  return { props: {} };
}
